module.exports = __webpack_public_path__ + "assets/img/honor9.44019447.jpg";